module.exports = __webpack_public_path__ + "static/media/folder-times.3594c679.svg";